var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 74091"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1534",
    d: "M6.265 6.592a.771.771 0 0 1 1.208-.215c.845.838 1.684 1.684 2.528 2.524q1.255-1.25 2.506-2.5a.767.767 0 0 1 1.1 1.063c-.838.846-1.684 1.684-2.524 2.528.84.845 1.687 1.684 2.526 2.53a.766.766 0 0 1-1.061 1.105c-.854-.846-1.7-1.7-2.552-2.548-.845.84-1.684 1.685-2.529 2.525a.767.767 0 0 1-1.309-.539.781.781 0 0 1 .249-.57q1.25-1.252 2.5-2.5-1.25-1.255-2.5-2.505a.77.77 0 0 1-.142-.898Z",
    fill: "#f91c1c"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 180",
    fill: "none",
    stroke: "#ffadad",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelTick);
export default __webpack_public_path__ + "static/media/cancelTick.fe9fc825968d4487d004d50c8eaf6a14.svg";
export { ForwardRef as ReactComponent };